import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import FeaturedList from './FeaturedList';

const Courses = ({moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, cobrandId, model}) => {
  const [{ data, loading }] = useAxios({ url: `internal/cobrand/crsids/${cobrandId ? cobrandId : ''}`, method: "get" });
  
    return (
        <FeaturedList
        moveItem={(index, direction) => moveItem("crs", index, direction)}
        addItem={(option) => addItem("crs", option)}
        removeItem={(id) => removeItem("crs", id)}
        saveIndividual={saveIndividual}
        showUpdateBtn={showUpdateBtn}
        typeId={1}
        type="Courses" model={model} availableItems={data} />
    );
};

export default Courses;
